var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.images),function(image,index){return _c('v-col',{key:image,attrs:{"cols":"12","xs":"12","sm":"4"}},[_c('v-img',{staticClass:"slide-in-left",style:({ animationDelay: `${index * 100}ms` }),attrs:{"max-height":"300px","max-width":"300px","src":`${_vm.baseUrl}/api/gallery/${image}`}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }